
export function topicData(StyleItems) {
  return new Promise((resolve, reject) => {
    var answerBox = new Array(); //把后台接口返回所有类型题目拆分储存在一个数组里面，
    for (var i in StyleItems) {
      //循环题目类型对数组
      //ATEST
      if (
        StyleItems[i].Type == "ATEST" ||
        StyleItems[i].Type == "PDTEST" ||
        StyleItems[i].Type == "XTEST"
      ) {
        let TestItems = StyleItems[i].TestItems;
        for (let j in TestItems) {
          //循环题目类型下的选项
          //把需要用到的字段，加到answerBox数组里面，方便判断类型
          TestItems[j]["Type"] = StyleItems[i].Type; //判断是否单选多选
          TestItems[j]["SubType"] = StyleItems[i].SubType; //"单项"
          TestItems[j]["Style"] = StyleItems[i].Style; //"B1型题"
          TestItems[j]["StyleID"] = StyleItems[i].StyleID; //"B1型题"
          TestItems[j]["Score"] = StyleItems[i].Score; //"得分"
          TestItems[j]["FrontTitle"] = ""; //
          TestItems[j]["AnswerArray"] = TestItems[j].Answer.split(""); //用于判断答案是否颜色选中

          if (TestItems[j]["Type"] == "PDTEST") {
            let Content = [
              {
                Content: "对",
                ItemName: "A",
              },
              {
                Content: "错",
                ItemName: "B",
              },
            ];
            TestItems[j]["SelectedItems"] = Content; //"B1型题"
            TestItems[j]["UserNote"] = "";
          }

          for (let w in TestItems[j].SelectedItems) {
            //在题目存入一个true,false,状态，方便控制题目是否选中状态
            TestItems[j].SelectedItems[w]["open"] = false;
          }
          //把用户操作数据放进题目里
          answerBox.push(TestItems[j]);
        }
      }
      // A3TEST(A3TestItems)
      if (StyleItems[i].Type == "A3TEST") {
        let TestItems = StyleItems[i].TestItems;
        for (let j in TestItems) {
          //循环题目类型下的选项
          let TestItemsb = TestItems[j].A3TestItems;
          for (let b in TestItemsb) {
            TestItemsb[b]["SubType"] = StyleItems[i].SubType; //"单项"
            TestItemsb[b]["Style"] = StyleItems[i].Style; //"B1型题"
            TestItemsb[b]["FrontTitle"] = TestItems[j].FrontTitle; //主干
            TestItemsb[b]["Type"] = StyleItems[i].Type; //判断是否单选多选
            TestItemsb[b]["StyleID"] = StyleItems[i].StyleID; //"B1型题"
            TestItemsb[b]["AllTestID"] = TestItems[j].AllTestID;
            TestItemsb[b]["A3TestID"] = TestItems[j].A3TestID;
            TestItemsb[b]["CptID"] = TestItems[j].CptID;
            TestItemsb[b]["IsFav"] = TestItems[j].IsFav;
            TestItemsb[b]["SbjID"] = TestItems[j].SbjID;
            TestItemsb[b]["Score"] = StyleItems[i].Score;
            TestItemsb[b]["SrcID"] = TestItems[j].SrcID;
            TestItemsb[b]["StyleType"] = TestItems[j].StyleType;
            TestItemsb[b]["AnswerArray"] = TestItemsb[b].Answer.split(""); //用于判断答案是否颜色选中

            for (let v in TestItemsb[b].SelectedItems) {
              TestItemsb[b].SelectedItems[v]["open"] = false;
            }
            answerBox.push(TestItemsb[b]);
          }
        }
      }
      //BTEST(BTestItems)
      if (StyleItems[i].Type == "BTEST") {
        let TestItems = StyleItems[i].TestItems;
        for (let j in TestItems) {
          //循环题目类型下的选项
          let TestItemsb = TestItems[j].BTestItems;
          for (let b in TestItemsb) {
            TestItemsb[b]["SubType"] = StyleItems[i].SubType; //"单项"
            TestItemsb[b]["Style"] = StyleItems[i].Style; //"B1型题"
            TestItemsb[b]["SelectedItems"] = JSON.parse(
              JSON.stringify(TestItems[j].SelectedItems)
            ); //"问题 深拷贝"
            TestItemsb[b]["FrontTitle"] = TestItems[j].FrontTitle; //主干
            TestItemsb[b]["Type"] = StyleItems[i].Type; //判断是否单选多选
            TestItemsb[b]["StyleID"] = StyleItems[i].StyleID; //"B1型题"
            TestItemsb[b]["AllTestID"] = TestItems[j].AllTestID;
            TestItemsb[b]["BTestID"] = TestItems[j].BTestID;
            TestItemsb[b]["CptID"] = TestItems[j].CptID;
            TestItemsb[b]["IsFav"] = TestItems[j].IsFav;
            TestItemsb[b]["SbjID"] = TestItems[j].SbjID;
            TestItemsb[b]["Score"] = StyleItems[i].Score;
            TestItemsb[b]["SrcID"] = TestItems[j].SrcID;
            TestItemsb[b]["StyleType"] = TestItems[j].StyleType;
            TestItemsb[b]["AnswerArray"] = TestItemsb[b].Answer.split(""); //用于判断答案是否颜色选中
            for (let v in TestItemsb[b].SelectedItems) {
              TestItemsb[b].SelectedItems[v]["open"] = false;
            }
            answerBox.push(TestItemsb[b]);
          }
        }
      }
      if (StyleItems[i].Type == "JDTEST") {
        let TestItems = StyleItems[i].TestItems;
        for (let d in TestItems) {
          TestItems[d]["Style"] = StyleItems[i].Style; //"B1型题"
          TestItems[d]["StyleID"] = StyleItems[i].StyleID; //"B1型题"
          TestItems[d]["Type"] = StyleItems[i].Type;
          answerBox.push(TestItems[d]);
        }
      }
    }
    resolve(answerBox);
  });
  
}

// 处理解析文本中的图片
export function setImgUrl(text, appEName) {
  const imgIdxArr = [] // '['的位置
  const newImgIdxArr = [] // 图片的起始位置数组
  let curIndex = 0
  let newKnowledgeTxt = text
  if (text === '') return text
  while (text.length > curIndex && text.indexOf('[', curIndex) > -1) {
    const imgIndex = text.indexOf('[', curIndex)
    imgIdxArr.push(imgIndex)
    curIndex = imgIndex + 1
  }
  if (imgIdxArr.length === 0) return text
  for (let i = 0; i < imgIdxArr.length; i++) {
    const startIndex = imgIdxArr[i]
    const endIndex = text.indexOf(']', startIndex)
    if (endIndex > -1) {
      const picName = text.substring(startIndex + 1, endIndex)
      if ((picName.indexOf('.gif') >= 0) || (picName.indexOf('.GIF') >= 0) || (picName.indexOf('.jpg') >= 0) || (picName.indexOf('.JPG') >= 0) || (picName.indexOf('.png') >= 0) || (picName.indexOf('.PNG') >= 0)) {
        newImgIdxArr.push({ 'startIndex': startIndex, 'endIndex': endIndex + 1 })
      }
    }
  }
  if (newImgIdxArr.length === 0) return text
  for (let i = 0; i < newImgIdxArr.length; i++) {
    const str = text.substring(newImgIdxArr[i].startIndex, newImgIdxArr[i].endIndex)
    const picSrc = replaceImg(appEName, text.substring(newImgIdxArr[i].startIndex + 1, newImgIdxArr[i].endIndex - 1))
    newKnowledgeTxt = newKnowledgeTxt.replace(str, picSrc)
  }
  return newKnowledgeTxt
}
// 替换解析文本中的图片
function replaceImg(appEName, str) {
  const imgSrc = 'https://testimages.ksbao.com/tk_img/ImgDir_' + appEName + '/' + str
  const img = new Image()
  img.src = imgSrc
  if (img.width > window.innerWidth) {
    return ' <img style="width: 100%" src="https://testimages.ksbao.com/tk_img/ImgDir_' + appEName + '/' + str + '" / > '
  }
  return ' <img style="max-width: 100%" src="https://testimages.ksbao.com/tk_img/ImgDir_' + appEName + '/' + str + '" / > '
}
